import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "float-container h-100"
};
const _hoisted_2 = {
  class: "animation-mask h-100"
};
const _hoisted_3 = {
  class: "animation-fade-item flex-row-center h-100"
};
const _hoisted_4 = {
  class: "credits-text-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_image_cdn = _resolveComponent("image-cdn");
  return _openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["credits-container flex-row-center -short-version", {
      '-play-animation': $setup.isPlay
    }])
  }, [_createVNode(_component_image_cdn, {
    class: "credits-icon h-100",
    src: require('@/assets/images/credits/credits-icon@3x.png')
  }, null, 8, ["src"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_image_cdn, {
    src: require('@/assets/images/credits/credits-text-content@3x.png')
  }, null, 8, ["src"])])])])])], 2);
}